// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* User Dropdown Container */
.user-dropdown {
  position: relative;
  display: inline-block;
}

/* Trigger Button */
.user-dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  width: fit-content;
  max-width: 600px;
}

.user-dropdown-trigger:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
}

/* User Avatar */
.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
}

/* User Info in Trigger */
.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.user-greeting {
  font-size: 16px;
  opacity: 0.9;
  line-height: 1.2;
  font-weight: 400;
}

.user-account {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  line-height: 1.2;
  margin-top: 2px;
}

/* Dropdown Menu */
.user-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  min-width: 280px;
  max-width: 320px;
  z-index: 2000;
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
  border: 1px solid #e0e0e0;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Dropdown Header */
.dropdown-header {
  padding: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #f0f3f7 100%);
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar-large {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4D64C1 0%, #3d52a0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  color: white;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(77, 100, 193, 0.3);
  flex-shrink: 0;
}

.user-details {
  flex: 1 1;
  min-width: 0;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-email {
  font-size: 12px;
  color: #7f8c8d;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-role-badge {
  display: inline-block;
  padding: 3px 8px;
  background: #4D64C1;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Dropdown Sections */
.dropdown-section {
  padding: 8px 0;
}

.dropdown-section-title {
  padding: 8px 16px 4px;
  font-size: 11px;
  font-weight: 600;
  color: #95a5a6;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Dropdown Items */
.dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  text-align: left;
  color: #2c3e50;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
  font-family: inherit;
}

.dropdown-item:hover {
  background: #f8f9fa;
  color: #4D64C1;
  padding-left: 20px;
}

.dropdown-item i {
  width: 20px;
  text-align: center;
  font-size: 16px;
  color: #7f8c8d;
  transition: color 0.2s;
}

.dropdown-item:hover i {
  color: #4D64C1;
}

.dropdown-item span {
  flex: 1 1;
}

/* Sign Out Button Special Styling */
.dropdown-item.sign-out {
  color: #e74c3c;
}

.dropdown-item.sign-out:hover {
  background: #fee;
  color: #c0392b;
}

.dropdown-item.sign-out i {
  color: #e74c3c;
}

/* Divider */
.dropdown-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 0;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .user-dropdown-trigger {
    min-width: auto;
    padding: 6px 10px;
  }

  .user-greeting {
    display: none;
  }

  .user-account {
    font-size: 13px;
  }

  .user-dropdown-menu {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 12px 12px 0 0;
    max-width: 100%;
    animation: slideUp 0.3s ease-out;
    max-height: 80vh;
    overflow-y: auto;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
}

@media (max-width: 480px) {
  .user-info {
    display: none;
  }

  .user-dropdown-trigger {
    padding: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/userDropdown.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,6DAA6D;EAC7D,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;IACR,4BAA4B;IAC5B,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* User Dropdown Container */\n.user-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n/* Trigger Button */\n.user-dropdown-trigger {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  width: fit-content;\n  max-width: 600px;\n}\n\n.user-dropdown-trigger:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-1px);\n}\n\n/* User Avatar */\n.user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  flex-shrink: 0;\n}\n\n/* User Info in Trigger */\n.user-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.user-greeting {\n  font-size: 16px;\n  opacity: 0.9;\n  line-height: 1.2;\n  font-weight: 400;\n}\n\n.user-account {\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  line-height: 1.2;\n  margin-top: 2px;\n}\n\n/* Dropdown Menu */\n.user-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  min-width: 280px;\n  max-width: 320px;\n  z-index: 2000;\n  overflow: hidden;\n  animation: slideDown 0.2s ease-out;\n  border: 1px solid #e0e0e0;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Dropdown Header */\n.dropdown-header {\n  padding: 16px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #f0f3f7 100%);\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-avatar-large {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #4D64C1 0%, #3d52a0 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 18px;\n  color: white;\n  border: 3px solid white;\n  box-shadow: 0 2px 8px rgba(77, 100, 193, 0.3);\n  flex-shrink: 0;\n}\n\n.user-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.user-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-email {\n  font-size: 12px;\n  color: #7f8c8d;\n  margin-bottom: 6px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-role-badge {\n  display: inline-block;\n  padding: 3px 8px;\n  background: #4D64C1;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Dropdown Sections */\n.dropdown-section {\n  padding: 8px 0;\n}\n\n.dropdown-section-title {\n  padding: 8px 16px 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #95a5a6;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Dropdown Items */\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 16px;\n  background: none;\n  border: none;\n  text-align: left;\n  color: #2c3e50;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-decoration: none;\n  font-family: inherit;\n}\n\n.dropdown-item:hover {\n  background: #f8f9fa;\n  color: #4D64C1;\n  padding-left: 20px;\n}\n\n.dropdown-item i {\n  width: 20px;\n  text-align: center;\n  font-size: 16px;\n  color: #7f8c8d;\n  transition: color 0.2s;\n}\n\n.dropdown-item:hover i {\n  color: #4D64C1;\n}\n\n.dropdown-item span {\n  flex: 1;\n}\n\n/* Sign Out Button Special Styling */\n.dropdown-item.sign-out {\n  color: #e74c3c;\n}\n\n.dropdown-item.sign-out:hover {\n  background: #fee;\n  color: #c0392b;\n}\n\n.dropdown-item.sign-out i {\n  color: #e74c3c;\n}\n\n/* Divider */\n.dropdown-divider {\n  height: 1px;\n  background: #e0e0e0;\n  margin: 0;\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .user-dropdown-trigger {\n    min-width: auto;\n    padding: 6px 10px;\n  }\n\n  .user-greeting {\n    display: none;\n  }\n\n  .user-account {\n    font-size: 13px;\n  }\n\n  .user-dropdown-menu {\n    position: fixed;\n    top: auto;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 12px 12px 0 0;\n    max-width: 100%;\n    animation: slideUp 0.3s ease-out;\n    max-height: 80vh;\n    overflow-y: auto;\n  }\n\n  @keyframes slideUp {\n    from {\n      transform: translateY(100%);\n    }\n    to {\n      transform: translateY(0);\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .user-info {\n    display: none;\n  }\n\n  .user-dropdown-trigger {\n    padding: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
